import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSearchResults } from 'store/search/searchActions';
import { getQuery } from 'store/search/searchSelectors/querySelectors';
import { LIST_SEARCH_LIMIT } from 'config';

const SearchResultFetcher = ({ limit }) => {
  const dispatch = useDispatch();
  const query = useSelector(getQuery);

  useEffect(() => {
    dispatch(fetchSearchResults({ limit }));
  }, [query, limit, dispatch]);

  return null;
};

SearchResultFetcher.propTypes = {
  limit: PropTypes.number,
};

SearchResultFetcher.defaultProps = {
  limit: LIST_SEARCH_LIMIT,
};

export default SearchResultFetcher;
